module.exports = __webpack_public_path__ + "img/myInvoice-select.be48f046.svg";